"use client";
import { useViewMode } from "@/context/ViewModeContext";
import { useEffect } from "react";

export default function ViewModeController() {
  const { viewMode } = useViewMode();
  
  useEffect(() => {
    // Root element'e data-view-mode attribute'u ekle
    document.documentElement.setAttribute("data-view-mode", viewMode);
  }, [viewMode]);
  
  return null;
}
